import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../../../context/commandsContext';
import useKeyPress from '../../../../../hooks/useKeyPress';
import {useMenu} from '../../../../../hooks/useMenu';
import BodyContentView from '../../../../views/bodyContentView';
import NoFlowInstallationVerification from './installation-verification';

function NoFlowInstallationFinished({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onComponent(<NoFlowInstallationVerification />);
  }, []);
  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onRight});
  }, [onRight]);

  return (
    <BodyContentView
      title="Installation Verification"
      left=""
      right="Finished"
      caption="Installation Verification passed.  The installation appears to meet specification."
    />
  );
}

export default NoFlowInstallationFinished;
